// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-section{
    display: flex;
    flex-wrap: wrap;
    color: var(--text-color);
    height: 100vh;
    scroll-snap-align: center;
    overflow: hidden;
    justify-content: center;
    justify-content: center;
    box-shadow: 20px 20px 50px rgba(0, 0, 0, 0.5);
    background: rgb(255, 255, 255, 0.1);
    z-index: 100;
}

.about-section::-webkit-scrollbar{display: none;}

.smal{
    display: none;
}

.larg{
    align-items: center;
    justify-content: center;
}

@media(max-width:998px){
    .larg{
        display: none;
    }

    .smal{
        position: relative;
        display:block;
        height: -moz-fit-content;
        height: fit-content;
    }
    
    .about-section{
        height: -moz-fit-content;
        height: fit-content;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/About/About.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,wBAAwB;IACxB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;IACvB,6CAA6C;IAC7C,mCAAmC;IACnC,YAAY;AAChB;;AAEA,kCAAkC,aAAa,CAAC;;AAEhD;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,wBAAmB;QAAnB,mBAAmB;IACvB;;IAEA;QACI,wBAAmB;QAAnB,mBAAmB;IACvB;AACJ","sourcesContent":[".about-section{\n    display: flex;\n    flex-wrap: wrap;\n    color: var(--text-color);\n    height: 100vh;\n    scroll-snap-align: center;\n    overflow: hidden;\n    justify-content: center;\n    justify-content: center;\n    box-shadow: 20px 20px 50px rgba(0, 0, 0, 0.5);\n    background: rgb(255, 255, 255, 0.1);\n    z-index: 100;\n}\n\n.about-section::-webkit-scrollbar{display: none;}\n\n.smal{\n    display: none;\n}\n\n.larg{\n    align-items: center;\n    justify-content: center;\n}\n\n@media(max-width:998px){\n    .larg{\n        display: none;\n    }\n\n    .smal{\n        position: relative;\n        display:block;\n        height: fit-content;\n    }\n    \n    .about-section{\n        height: fit-content;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
